import { CMDBaseResult } from "./CMDBaseResult"
import { CMDSpCarnivaltreasureResult } from "./CMDSpCarnivaltreasureResult"
import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDCarnivaltreasure implements ICommand
{

	public BaseResult : CMDBaseResult;
	public Detail : CMDSpCarnivaltreasureResult;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.BaseResult = new CMDBaseResult();
		this.BaseResult.fromBytes(ba);
		this.Detail = new CMDSpCarnivaltreasureResult();
		this.Detail.fromBytes(ba);
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		let tempBuf0 = this.BaseResult.toBytes().toBuffer();
		ba.appendBuf(tempBuf0)
		let tempBuf1 = this.Detail.toBytes().toBuffer();
		ba.appendBuf(tempBuf1)

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDCarnivaltreasure();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'BaseResult(CMDBaseResult)='+this.BaseResult+' ';
		str += 'Detail(CMDSpCarnivaltreasureResult)='+this.Detail+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 0;
	}

	public getCmdName() : string
	{
		return 'Carnivaltreasure';
	}

}
